export default __webpack_public_path__ + "static/media/map.2af11552.svg";